import useTracker from '@hooks/useTracker';
import { PIN_CHANGE_ACCOUNT, CREATE_PIN_6DIGIT, CONFIRM_PIN_6DIGIT } from '@services/trackerConst';

const useEventTracker = () => {
  const { trackEvent, setUserId, resetTracker } = useTracker();

  const eventClickLogout = () => {
    trackEvent(PIN_CHANGE_ACCOUNT);
    setUserId(null);
    resetTracker();
  };

  const eventCreatePin6Digit = () => {
    trackEvent(CREATE_PIN_6DIGIT);
  };

  const eventConfirmPin6Digit = (props) => {
    trackEvent(CONFIRM_PIN_6DIGIT, props);
  };

  return {
    eventClickLogout,
    eventCreatePin6Digit,
    eventConfirmPin6Digit,
  };
};

export default useEventTracker;
